import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { shouldRenderMobile } from '@philips-emr/hpms-components';
import HpmsCustomCardAPI from '@philips-emr/hpms-components/lib/components/hpms-custom-card/hpms-custom-card-api';
import { DeckAPI, FetchAPI, Token } from '@philips-emr/tws-components';
import { Type } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { MensagensResumoAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../base/base-controller';

import './mensagens-resumo.css';
import { Mensagem, StatusMensagem } from './mensagens-controller';

@Controller({ fragment: FragmentNames.MENSAGENS_RESUMO })
class MensagensResumoController extends BaseController {

  @Inject(Aliases.DECK_MENSAGENS)
  private deckMensagens: DeckAPI;
  @Inject(Aliases.FETCH_MENSAGENS)
  private fetchMensagens: FetchAPI;

  @OnAfterFetch(Aliases.FETCH_MENSAGENS)
  onAfterFetchMessages(event: FetchEvent): void {
    if (event.data) {
      const messages = event.data as Mensagem[];
      const messagesFormattedData = messages.map((data) => {
        return {
          ...data,
        };
      });
      this.fetchMensagens.setState({ data: messagesFormattedData });
      this.deckMensagens.setDone(true);
    }
  }

  @OnDynamicContentRender(Aliases.FIELD_IMPORTANT)
  onDynamicRender(event: RenderEvent): void {

    const { data, render } = event;
    const { ieImportante } = data as unknown as Mensagem;

    if (ieImportante == 'S') {
      render(() => (
        <div className="u-token-important"> <Token type={Type.DANGER} value={'Importante'} enabled /> </div>
      ));
    }
  }

  @OnMount(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onMountHpmsCustomCardMessages(event: MountEvent): void {
    const api = event.target as HpmsCustomCardAPI;
    const data = api.state;
    const { ieLeitura } = data as unknown as Mensagem;
    if (ieLeitura !== StatusMensagem.YES) {
      api.setBackground('hsl(var(--color-5))');
    }
  }

  @OnDynamicContentRender(Aliases.HPMS_CUSTOM_CARD_MENSAGENS)
  onDynamicContentRenderCustomCardMessages(event: RenderEvent): void {
    const { data, render } = event;
    const { ieLeitura } = data as Mensagem;
    if (!shouldRenderMobile()) {
      let TokenLeituraNaoLida: ReactElement = <></>;
      if (ieLeitura !== StatusMensagem.YES) {
        TokenLeituraNaoLida =
          <div className="u-token-bullet">
            <Token type={Type.NOTICE} value={''} />
          </div>;
      }
      render(() => <>
        {TokenLeituraNaoLida}
      </>);
    }
  }
}

export {
  MensagensResumoController,
};
